import { fetchWithRefresh } from "../../api/FetchWithRefresh";
import { logger } from "../../observability/LoggerFactory";
import type { paths } from "../../api/generated/api-types";

type GetCredentialPasswordResponse =
  paths["/credentials/{credentialId}/password"]["get"]["responses"]["200"]["content"]["application/json"];

// Единая форма тела ошибки бэкенда: обработчики читают из него текст сообщения.
interface ErrorBody {
  // Отсутствует, когда бэкенд ответил ошибкой без разобранного тела: сообщение
  // тогда собирается из кода ответа.
  error?: string;
}

export async function getCredentialPassword(credentialId: string): Promise<string> {
  const response = await fetchWithRefresh(`/api/credentials/${encodeURIComponent(credentialId)}/password`);
  if (!response.ok) {
    let errorMessage = `HTTP ${response.status}`;
    try {
      const body = (await response.json()) as ErrorBody;
      if (typeof body.error === "string" && body.error.length > 0) {
        errorMessage = body.error;
      }
    } catch (error: unknown) {
      // Тело ответа не JSON: сообщение остаётся собранным из кода состояния.
      logger.warn({ err: error, component: "getCredentialPassword" }, "Error response body is not JSON");
    }
    throw new Error(errorMessage);
  }
  const body = (await response.json()) as GetCredentialPasswordResponse;
  return body.password;
}
